<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Renew certificate</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="card-body">
                <dl class="pairs">
                    <div>
                        <dt>Certificate</dt>
                        <dd>{{ modalData.commonName }}</dd>
                    </div>
                </dl>

                <p class="step-say">Renewing starts issuance over for this certificate. Traffic keeps flowing on the
                    certificate deployed today until the new one takes its place.</p>

                <div class="renew-panel">
                    <div class="renew-head">
                        <i class="fa fa-triangle-exclamation renew-ico"></i>
                        <span class="renew-title">What renewing does</span>
                    </div>
                    <ul class="renew-list">
                        <li>A new signing request is generated for the same domains.</li>
                        <li>Your certificate authority has to sign it, and you upload the result again.</li>
                        <li>Deployment to the edge restarts from the beginning once that is done.</li>
                    </ul>
                </div>

                <div class="alert alert-danger mb-0 mt-3" role="alert" v-if="error">{{ error }}</div>
            </div>

            <div class="card-footer d-flex align-items-center gap-3">
                <div class="ms-auto d-flex gap-2">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        :disabled="renewInProgress">Cancel</button>
                    <button class="btn btn-primary" :disabled="renewInProgress">
                        <div v-if="renewInProgress" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            Renew
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            renewInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "RenewCertificate",
    methods: {
        ...mapActions("aut", {
            renewCertificate: "renewCertificate",
        }),
        async onFormSubmit() {
            this.renewInProgress = true;
            this.error = "";
            let toastOptions = {
                message: "Certificate renewed successfully.",
                type: "success"
            }
            try {
                await this.renewCertificate({commonName: this.modalData.commonName, payload: {}})
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                toastOptions = {
                    message: this.error || "Something went wrong while renewing certificates. Please contact support.",
                    type: "error"
                }
                return;
            } finally {
                this.renewInProgress = false;
                this.$store.dispatch("addToast", toastOptions);
            }
            this.$store.dispatch("hideModal");
            this.$store.state.aut.renewCertTrigger = !this.$store.state.aut.renewCertTrigger;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../theme/scss/user-variables' as *;

.pairs {
    margin: 0 0 1rem;
}

.pairs>div {
    display: grid;
    grid-template-columns: 6rem 1fr;
    gap: 1rem;
    align-items: baseline;
}

.pairs dt {
    font-weight: 400;
    color: #6E84A3;
    font-size: .8125rem;
    margin: 0;

    body.dark-mode & {
        color: $dark-text-secondary;
    }
}

.pairs dd {
    margin: 0;
    font-size: .8125rem;
    word-break: break-all;
}

.step-say {
    font-size: .8125rem;
    color: #6E84A3;
    margin: 0 0 1.25rem;

    body.dark-mode & {
        color: $dark-text-secondary;
    }
}

/* What renewing does ----------------------------------------------------- */
.renew-panel {
    border: 1px solid #F7E2A8;
    border-radius: .5rem;
    background: #FFFCF3;
    padding: .9rem 1.15rem;

    body.dark-mode & {
        border-color: rgba(246, 195, 67, .35);
        background: rgba(246, 195, 67, .08);
    }
}

.renew-head {
    display: flex;
    align-items: center;
    gap: .55rem;
}

.renew-ico {
    color: #F6C343;
}

.renew-title {
    font-weight: 600;
    font-size: .875rem;
}

.renew-list {
    margin: .5rem 0 0;
    padding-left: 1.85rem;
    font-size: .8125rem;
    color: #3B506C;

    li+li {
        margin-top: .3rem;
    }

    body.dark-mode & {
        color: $dark-text-primary;
    }
}
</style>
